// extracted by mini-css-extract-plugin
export const bioCard = "bio-cards-module--bioCard--MXgvd";
export const bioImage = "bio-cards-module--bioImage--3atT-";
export const bioInfo = "bio-cards-module--bioInfo--1EE9t";
export const name = "bio-cards-module--name--QJJAA";
export const title = "bio-cards-module--title--1kJiG";
export const bio = "bio-cards-module--bio--1lBq-";
export const link = "bio-cards-module--link--3TSMA";
export const buttonPanel = "bio-cards-module--buttonPanel--24nh3";